export const getMultiplierFromStreak = (streak: number): number => {
  if (streak === 0) return 1;
  if (streak < 10) return 1 + streak * 0.1;
  return 2;
};
